/**
 * Génère une image "Nouveau record" brandée Body-Up, prête à partager (Instagram/WhatsApp).
 * Format portrait 4:5 (1080x1350), même style de branding que shareTransformation.js
 * (pas de photo ici : juste les chiffres du record, mis en scène).
 */

import QRCode from 'qrcode';

const W = 1080;
const H = 1350;
const RECORD_URL = 'https://body-up.ch';

const loadImg = (url) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = url;
});

function wrapText(ctx, text, maxWidth) {
  const words = (text || '').split(' ');
  const lines = [];
  let cur = '';
  words.forEach((w) => {
    const test = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(test).width > maxWidth && cur) { lines.push(cur); cur = w; } else { cur = test; }
  });
  if (cur) lines.push(cur);
  return lines.slice(0, 2);
}

export async function buildRecordImage({ exerciseName, oldWeight, newWeight, pctChange, en }) {
  const canvas = document.createElement('canvas');
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');

  const bg = ctx.createLinearGradient(0, 0, 0, H);
  bg.addColorStop(0, '#1a1206');
  bg.addColorStop(0.5, '#0a0a0a');
  bg.addColorStop(1, '#000000');
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, W, H);

  const hg = ctx.createLinearGradient(0, 0, W, 0);
  hg.addColorStop(0, '#F59E0B');
  hg.addColorStop(1, '#EAB308');
  ctx.fillStyle = hg;
  ctx.fillRect(0, 0, W, 172);
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'left';
  ctx.fillStyle = '#111';
  ctx.font = '800 66px Outfit, Arial';
  ctx.fillText('BODY-UP', 56, 72);
  ctx.font = '600 24px Manrope, Arial';
  ctx.fillStyle = 'rgba(0,0,0,0.7)';
  ctx.fillText('PERSONAL TRAINING · NYON', 60, 122);
  ctx.textAlign = 'right';
  ctx.fillStyle = '#111';
  ctx.font = '800 32px Outfit, Arial';
  ctx.fillText(en ? 'NEW RECORD' : 'NOUVEAU RECORD', W - 56, 86);

  const cx = W / 2;
  const trophyY = 340;
  ctx.save();
  const tg = ctx.createLinearGradient(cx - 90, trophyY - 90, cx + 90, trophyY + 90);
  tg.addColorStop(0, '#FCD34D');
  tg.addColorStop(1, '#F59E0B');
  ctx.fillStyle = tg;
  ctx.shadowColor = 'rgba(245,158,11,0.55)';
  ctx.shadowBlur = 60;
  ctx.beginPath();
  ctx.arc(cx, trophyY, 100, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
  ctx.fillStyle = '#1a1206';
  ctx.font = '800 90px Outfit, Arial';
  ctx.textAlign = 'center';
  ctx.fillText('🏆', cx, trophyY + 12);

  ctx.fillStyle = '#fff';
  ctx.font = '800 52px Outfit, Arial';
  ctx.textAlign = 'center';
  const nameLines = wrapText(ctx, exerciseName, W - 160);
  let ny = 540;
  nameLines.forEach((line) => { ctx.fillText(line, cx, ny); ny += 62; });

  const rowY = ny + 60;
  ctx.font = '600 34px Manrope, Arial';
  ctx.fillStyle = 'rgba(255,255,255,0.55)';
  ctx.fillText(en ? 'Estimated 1RM' : '1RM estimée', cx, rowY - 50);

  ctx.font = '700 46px Outfit, Arial';
  ctx.fillStyle = 'rgba(255,255,255,0.5)';
  ctx.fillText(`${oldWeight} kg`, cx - 180, rowY + 20);
  ctx.font = '800 30px Outfit, Arial';
  ctx.fillStyle = '#F59E0B';
  ctx.fillText('→', cx, rowY + 20);
  ctx.font = '800 66px Outfit, Arial';
  ctx.fillStyle = '#FCD34D';
  ctx.fillText(`${newWeight} kg`, cx + 190, rowY + 24);

  const pctTxt = `+${pctChange}%`;
  ctx.font = '800 44px Outfit, Arial';
  const bw = ctx.measureText(pctTxt).width + 100;
  const by = rowY + 90;
  ctx.fillStyle = '#F59E0B';
  ctx.beginPath();
  ctx.roundRect(cx - bw / 2, by, bw, 78, 39);
  ctx.fill();
  ctx.fillStyle = '#111';
  ctx.fillText(pctTxt, cx, by + 40);

  const fy = H - 138;
  ctx.fillStyle = 'rgba(255,255,255,0.06)';
  ctx.fillRect(0, fy - 22, W, 160);

  let qrImg = null;
  try {
    const qrDataUrl = await QRCode.toDataURL(RECORD_URL, { margin: 1, width: 240, color: { dark: '#0a0a0a', light: '#ffffff' } });
    qrImg = await loadImg(qrDataUrl);
  } catch { qrImg = null; }
  const qrSize = 118;
  const qrX = W - 56 - qrSize;
  const qrY = fy - 8;
  if (qrImg) {
    ctx.fillStyle = '#fff';
    ctx.beginPath();
    ctx.roundRect(qrX - 8, qrY - 8, qrSize + 16, qrSize + 16, 14);
    ctx.fill();
    ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);
    ctx.fillStyle = 'rgba(255,255,255,0.92)';
    ctx.font = '700 19px Manrope, Arial';
    ctx.textAlign = 'center';
    ctx.fillText(en ? 'Coach with Laurent' : 'Coache avec Laurent', qrX + qrSize / 2, qrY + qrSize + 22);
  }

  ctx.textAlign = 'left';
  ctx.fillStyle = '#fff';
  ctx.font = '700 27px Manrope, Arial';
  ctx.fillText('Tél +41 78 604 44 23  ·  info@body-up.ch', 56, fy + 18);
  ctx.font = '600 23px Manrope, Arial';
  ctx.fillStyle = 'rgba(255,255,255,0.82)';
  ctx.fillText("Route des Tattes d'Oie 95, 1260 Nyon", 56, fy + 56);
  ctx.fillStyle = '#F59E0B';
  ctx.font = '800 25px Outfit, Arial';
  ctx.fillText('body-up.ch', 56, fy + 96);

  return new Promise((resolve) => canvas.toBlob((b) => resolve(b), 'image/jpeg', 0.92));
}

export async function shareRecordImage({ exerciseName, oldWeight, newWeight, pctChange, en }) {
  const blob = await buildRecordImage({ exerciseName, oldWeight, newWeight, pctChange, en });
  const file = new File([blob], 'body-up-record.jpg', { type: 'image/jpeg' });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({
      files: [file], title: 'Body-Up',
      text: en ? `New personal record: ${exerciseName} 💪` : `Nouveau record personnel : ${exerciseName} 💪`,
    });
    return 'shared';
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = 'body-up-record.jpg'; a.click();
  URL.revokeObjectURL(url);
  return 'downloaded';
}
